import { MenuItem, TextField, Tooltip, type SxProps, type Theme } from '@mui/material'
import { MODOS_COMPARACAO, type ModoComparacao } from '../pages/home/comparacao'

export type ComparacaoSelectProps = {
  value: ModoComparacao
  onChange: (modo: ModoComparacao) => void
  disabled?: boolean
  sx?: SxProps<Theme>
}

/**
 * "Comparado com:" — escolhe a janela contra a qual o período é medido.
 *
 * O Upseller só compara com o período anterior; mês contra mês era o que
 * faltava lá. O backend já aceita as quatro datas, então a escolha é do front.
 */
export function ComparacaoSelect({ value, onChange, disabled, sx }: ComparacaoSelectProps) {
  return (
    <TextField
      select
      size="small"
      label="Comparado com"
      value={value}
      onChange={(e) => onChange(e.target.value as ModoComparacao)}
      disabled={disabled}
      sx={sx}
    >
      {MODOS_COMPARACAO.map((m) => (
        <MenuItem key={m.id} value={m.id}>
          <Tooltip title={m.hint} placement="right">
            <span>{m.label}</span>
          </Tooltip>
        </MenuItem>
      ))}
    </TextField>
  )
}
